

import React from 'react'
// import CmsData from '../components/cms-data'
import Cmsweb from '../components/cms-webdata'
import CMSWebDetail from '../components/cmsWeb-detail'
import LeadCMSweb from '../components/Lead-cmsweb'
import CmsWebPlanTable from '../components/cms-web-plan'
import usePageMeta from '../hooks/usePageMeta';
export default function CmsWeb() {
    usePageMeta('Custom CMS Website Development | Spinnennetz', 'Empower your business with custom CMS web development. Spinnennetz builds scalable content management systems for easy website updates and effortless scaling.', '/cms-web', {"@context":"https://schema.org","@type":"Service","name":"Custom CMS Website Development","provider":{"@type":"Organization","name":"Spinnennetz"}}, 'custom CMS development, enterprise content management system, custom web development services, headless CMS development');
    return (
        <>
        <CMSWebDetail/>
        {/* <CmsData /> */}
        <Cmsweb/>
        <CmsWebPlanTable/>
        <LeadCMSweb/>
        </>
    )
}
